import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../../auth/actionAuth";
import { actionOutskirtsInfoReceived } from "../actionOutskirtsInfo";
export var epicLoadOutskirtsInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAuth.Login), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.OutskirtsInfo,
            props: {
                playerId: action.playerId,
            },
        });
    }), retry(), map(actionOutskirtsInfoReceived));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/epics/epicLoadOutskirtsInfo.ts
// module id = 1918
// module chunks = 3